export const LOGIN_TRIED = 'loginTried';
